export default "__VITE_ASSET__CvN1xk7L__"